var _defs, _rect, _rect2, _rect3, _rect4, _rect5, _rect6, _rect7, _rect8, _image;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTecamaQrcode(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 1024,
    height: 1024,
    viewBox: "0 0 1024 1024",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-dot-color"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 62 310v 31h 31v -15.5a 15.5 15.5, 0, 0, 0, -15.5 -15.5",
    transform: "rotate(-90,77.5,325.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 62,
    y: 341,
    width: 31,
    height: 31,
    transform: "rotate(0,77.5,356.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 62,
    y: 372,
    width: 31,
    height: 31,
    transform: "rotate(0,77.5,387.5)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 62 403v 31h 31v -15.5a 15.5 15.5, 0, 0, 0, -15.5 -15.5",
    transform: "rotate(180,77.5,418.5)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 62 496v 31h 31v -15.5a 15.5 15.5, 0, 0, 0, -15.5 -15.5",
    transform: "rotate(-90,77.5,511.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 62,
    y: 527,
    width: 31,
    height: 31,
    transform: "rotate(0,77.5,542.5)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 62 558v 31h 15.5a 15.5 15.5, 0, 0, 0, 0 -31",
    transform: "rotate(90,77.5,573.5)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 62 620v 31h 15.5a 15.5 15.5, 0, 0, 0, 0 -31",
    transform: "rotate(180,77.5,635.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 93,
    y: 310,
    width: 31,
    height: 31,
    transform: "rotate(0,108.5,325.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 93,
    y: 341,
    width: 31,
    height: 31,
    transform: "rotate(0,108.5,356.5)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 93 403v 31h 15.5a 15.5 15.5, 0, 0, 0, 0 -31",
    transform: "rotate(0,108.5,418.5)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 93 465v 31h 31v -15.5a 15.5 15.5, 0, 0, 0, -15.5 -15.5",
    transform: "rotate(-90,108.5,480.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 93,
    y: 496,
    width: 31,
    height: 31,
    transform: "rotate(0,108.5,511.5)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 93 527v 31h 31v -15.5a 15.5 15.5, 0, 0, 0, -15.5 -15.5",
    transform: "rotate(90,108.5,542.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 93,
    y: 620,
    width: 31,
    height: 31,
    transform: "rotate(0,108.5,635.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 124,
    y: 310,
    width: 31,
    height: 31,
    transform: "rotate(0,139.5,325.5)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 124 341v 31h 31v -15.5a 15.5 15.5, 0, 0, 0, -15.5 -15.5",
    transform: "rotate(90,139.5,356.5)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 124 434v 31h 31v -15.5a 15.5 15.5, 0, 0, 0, -15.5 -15.5",
    transform: "rotate(-90,139.5,449.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 124,
    y: 465,
    width: 31,
    height: 31,
    transform: "rotate(0,139.5,480.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 124,
    y: 620,
    width: 31,
    height: 31,
    transform: "rotate(0,139.5,635.5)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 124 651v 31h 15.5a 15.5 15.5, 0, 0, 0, 0 -31",
    transform: "rotate(90,139.5,666.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 155,
    y: 310,
    width: 31,
    height: 31,
    transform: "rotate(0,170.5,325.5)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 155 372v 31h 15.5a 15.5 15.5, 0, 0, 0, 0 -31",
    transform: "rotate(-90,170.5,387.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 155,
    y: 403,
    width: 31,
    height: 31,
    transform: "rotate(0,170.5,418.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 155,
    y: 434,
    width: 31,
    height: 31,
    transform: "rotate(0,170.5,449.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 155,
    y: 465,
    width: 31,
    height: 31,
    transform: "rotate(0,170.5,480.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 155,
    y: 496,
    width: 31,
    height: 31,
    transform: "rotate(0,170.5,511.5)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 155 527v 31h 15.5a 15.5 15.5, 0, 0, 0, 0 -31",
    transform: "rotate(90,170.5,542.5)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 155 620v 31h 15.5a 15.5 15.5, 0, 0, 0, 0 -31",
    transform: "rotate(0,170.5,635.5)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 186 310v 31h 31v -15.5a 15.5 15.5, 0, 0, 0, -15.5 -15.5",
    transform: "rotate(0,201.5,325.5)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 186 341v 31h 15.5a 15.5 15.5, 0, 0, 0, 0 -31",
    transform: "rotate(90,201.5,356.5)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 186 403v 31h 15.5a 15.5 15.5, 0, 0, 0, 0 -31",
    transform: "rotate(0,201.5,418.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 186,
    y: 465,
    width: 31,
    height: 31,
    transform: "rotate(0,201.5,480.5)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 186 496v 31h 31v -15.5a 15.5 15.5, 0, 0, 0, -15.5 -15.5",
    transform: "rotate(90,201.5,511.5)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 201.5,
    cy: 573.5,
    r: 15.5,
    transform: "rotate(0,201.5,573.5)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 186 651v 31h 15.5a 15.5 15.5, 0, 0, 0, 0 -31",
    transform: "rotate(180,201.5,666.5)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 217 372v 31h 15.5a 15.5 15.5, 0, 0, 0, 0 -31",
    transform: "rotate(180,232.5,387.5)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 217 465v 31h 15.5a 15.5 15.5, 0, 0, 0, 0 -31",
    transform: "rotate(0,232.5,480.5)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 232.5,
    cy: 542.5,
    r: 15.5,
    transform: "rotate(0,232.5,542.5)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 232.5,
    cy: 604.5,
    r: 15.5,
    transform: "rotate(0,232.5,604.5)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 217 651v 31h 15.5a 15.5 15.5, 0, 0, 0, 0 -31",
    transform: "rotate(0,232.5,666.5)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 248 310v 31h 15.5a 15.5 15.5, 0, 0, 0, 0 -31",
    transform: "rotate(180,263.5,325.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 248,
    y: 372,
    width: 31,
    height: 31,
    transform: "rotate(0,263.5,387.5)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 263.5,
    cy: 449.5,
    r: 15.5,
    transform: "rotate(0,263.5,449.5)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 248 496v 31h 15.5a 15.5 15.5, 0, 0, 0, 0 -31",
    transform: "rotate(180,263.5,511.5)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 248 558v 31h 15.5a 15.5 15.5, 0, 0, 0, 0 -31",
    transform: "rotate(180,263.5,573.5)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 248 620v 31h 15.5a 15.5 15.5, 0, 0, 0, 0 -31",
    transform: "rotate(180,263.5,635.5)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 263.5,
    cy: 697.5,
    r: 15.5,
    transform: "rotate(0,263.5,697.5)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 279 310v 31h 31v -15.5a 15.5 15.5, 0, 0, 0, -15.5 -15.5",
    transform: "rotate(0,294.5,325.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 279,
    y: 341,
    width: 31,
    height: 31,
    transform: "rotate(0,294.5,356.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 279,
    y: 372,
    width: 31,
    height: 31,
    transform: "rotate(0,294.5,387.5)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 279 403v 31h 31v -15.5a 15.5 15.5, 0, 0, 0, -15.5 -15.5",
    transform: "rotate(180,294.5,418.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 279,
    y: 496,
    width: 31,
    height: 31,
    transform: "rotate(0,294.5,511.5)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 279 558v 31h 31v -15.5a 15.5 15.5, 0, 0, 0, -15.5 -15.5",
    transform: "rotate(0,294.5,573.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 279,
    y: 589,
    width: 31,
    height: 31,
    transform: "rotate(0,294.5,604.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 279,
    y: 620,
    width: 31,
    height: 31,
    transform: "rotate(0,294.5,635.5)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 310 93v 31h 15.5a 15.5 15.5, 0, 0, 0, 0 -31",
    transform: "rotate(-90,325.5,108.5)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 310 124v 31h 31v -15.5a 15.5 15.5, 0, 0, 0, -15.5 -15.5",
    transform: "rotate(180,325.5,139.5)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 310 186v 31h 15.5a 15.5 15.5, 0, 0, 0, 0 -31",
    transform: "rotate(180,325.5,201.5)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 310 248v 31h 15.5a 15.5 15.5, 0, 0, 0, 0 -31",
    transform: "rotate(-90,325.5,263.5)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 310 279v 31h 31v -15.5a 15.5 15.5, 0, 0, 0, -15.5 -15.5",
    transform: "rotate(180,325.5,294.5)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 310 341v 31h 15.5a 15.5 15.5, 0, 0, 0, 0 -31",
    transform: "rotate(0,325.5,356.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 310,
    y: 403,
    width: 31,
    height: 31,
    transform: "rotate(0,325.5,418.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 310,
    y: 434,
    width: 31,
    height: 31,
    transform: "rotate(0,325.5,449.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 310,
    y: 465,
    width: 31,
    height: 31,
    transform: "rotate(0,325.5,480.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 310,
    y: 496,
    width: 31,
    height: 31,
    transform: "rotate(0,325.5,511.5)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 310 527v 31h 15.5a 15.5 15.5, 0, 0, 0, 0 -31",
    transform: "rotate(90,325.5,542.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 310,
    y: 620,
    width: 31,
    height: 31,
    transform: "rotate(0,325.5,635.5)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 325.5,
    cy: 697.5,
    r: 15.5,
    transform: "rotate(0,325.5,697.5)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 310 744v 31h 15.5a 15.5 15.5, 0, 0, 0, 0 -31",
    transform: "rotate(180,325.5,759.5)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 310 806v 31h 15.5a 15.5 15.5, 0, 0, 0, 0 -31",
    transform: "rotate(-90,325.5,821.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 310,
    y: 837,
    width: 31,
    height: 31,
    transform: "rotate(0,325.5,852.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 310,
    y: 868,
    width: 31,
    height: 31,
    transform: "rotate(0,325.5,883.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 310,
    y: 899,
    width: 31,
    height: 31,
    transform: "rotate(0,325.5,914.5)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 310 930v 31h 31v -15.5a 15.5 15.5, 0, 0, 0, -15.5 -15.5",
    transform: "rotate(180,325.5,945.5)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 356.5,
    cy: 77.5,
    r: 15.5,
    transform: "rotate(0,356.5,77.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 341,
    y: 124,
    width: 31,
    height: 31,
    transform: "rotate(0,356.5,139.5)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 341 186v 31h 31v -15.5a 15.5 15.5, 0, 0, 0, -15.5 -15.5",
    transform: "rotate(0,356.5,201.5)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 341 217v 31h 31v -15.5a 15.5 15.5, 0, 0, 0, -15.5 -15.5",
    transform: "rotate(180,356.5,232.5)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 341 279v 31h 31v -15.5a 15.5 15.5, 0, 0, 0, -15.5 -15.5",
    transform: "rotate(0,356.5,294.5)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 341 310v 31h 15.5a 15.5 15.5, 0, 0, 0, 0 -31",
    transform: "rotate(90,356.5,325.5)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 341 372v 31h 15.5a 15.5 15.5, 0, 0, 0, 0 -31",
    transform: "rotate(-90,356.5,387.5)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 341 403v 31h 31v -15.5a 15.5 15.5, 0, 0, 0, -15.5 -15.5",
    transform: "rotate(90,356.5,418.5)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 341 496v 31h 15.5a 15.5 15.5, 0, 0, 0, 0 -31",
    transform: "rotate(0,356.5,511.5)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 356.5,
    cy: 573.5,
    r: 15.5,
    transform: "rotate(0,356.5,573.5)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 341 620v 31h 31v -15.5a 15.5 15.5, 0, 0, 0, -15.5 -15.5",
    transform: "rotate(0,356.5,635.5)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 341 651v 31h 15.5a 15.5 15.5, 0, 0, 0, 0 -31",
    transform: "rotate(90,356.5,666.5)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 341 713v 31h 15.5a 15.5 15.5, 0, 0, 0, 0 -31",
    transform: "rotate(-90,356.5,728.5)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 341 744v 31h 31v -15.5a 15.5 15.5, 0, 0, 0, -15.5 -15.5",
    transform: "rotate(90,356.5,759.5)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 341 837v 31h 31v -15.5a 15.5 15.5, 0, 0, 0, -15.5 -15.5",
    transform: "rotate(0,356.5,852.5)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 341 868v 31h 31v -15.5a 15.5 15.5, 0, 0, 0, -15.5 -15.5",
    transform: "rotate(90,356.5,883.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 341,
    y: 930,
    width: 31,
    height: 31,
    transform: "rotate(0,356.5,945.5)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 372 124v 31h 31v -15.5a 15.5 15.5, 0, 0, 0, -15.5 -15.5",
    transform: "rotate(0,387.5,139.5)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 372 155v 31h 15.5a 15.5 15.5, 0, 0, 0, 0 -31",
    transform: "rotate(90,387.5,170.5)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 372 217v 31h 31v -15.5a 15.5 15.5, 0, 0, 0, -15.5 -15.5",
    transform: "rotate(0,387.5,232.5)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 372 248v 31h 15.5a 15.5 15.5, 0, 0, 0, 0 -31",
    transform: "rotate(90,387.5,263.5)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 372 341v 31h 15.5a 15.5 15.5, 0, 0, 0, 0 -31",
    transform: "rotate(180,387.5,356.5)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 387.5,
    cy: 697.5,
    r: 15.5,
    transform: "rotate(0,387.5,697.5)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 372 806v 31h 15.5a 15.5 15.5, 0, 0, 0, 0 -31",
    transform: "rotate(180,387.5,821.5)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 372 899v 31h 31v -15.5a 15.5 15.5, 0, 0, 0, -15.5 -15.5",
    transform: "rotate(-90,387.5,914.5)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 372 930v 31h 31v -15.5a 15.5 15.5, 0, 0, 0, -15.5 -15.5",
    transform: "rotate(90,387.5,945.5)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 418.5,
    cy: 77.5,
    r: 15.5,
    transform: "rotate(0,418.5,77.5)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 418.5,
    cy: 201.5,
    r: 15.5,
    transform: "rotate(0,418.5,201.5)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 403 341v 31h 15.5a 15.5 15.5, 0, 0, 0, 0 -31",
    transform: "rotate(0,418.5,356.5)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 403 651v 31h 15.5a 15.5 15.5, 0, 0, 0, 0 -31",
    transform: "rotate(180,418.5,666.5)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 403 713v 31h 15.5a 15.5 15.5, 0, 0, 0, 0 -31",
    transform: "rotate(-90,418.5,728.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 403,
    y: 744,
    width: 31,
    height: 31,
    transform: "rotate(0,418.5,759.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 403,
    y: 775,
    width: 31,
    height: 31,
    transform: "rotate(0,418.5,790.5)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 403 806v 31h 31v -15.5a 15.5 15.5, 0, 0, 0, -15.5 -15.5",
    transform: "rotate(90,418.5,821.5)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 403 899v 31h 15.5a 15.5 15.5, 0, 0, 0, 0 -31",
    transform: "rotate(0,418.5,914.5)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 434 248v 31h 15.5a 15.5 15.5, 0, 0, 0, 0 -31",
    transform: "rotate(-90,449.5,263.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 434,
    y: 279,
    width: 31,
    height: 31,
    transform: "rotate(0,449.5,294.5)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 434 310v 31h 15.5a 15.5 15.5, 0, 0, 0, 0 -31",
    transform: "rotate(90,449.5,325.5)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 434 651v 31h 15.5a 15.5 15.5, 0, 0, 0, 0 -31",
    transform: "rotate(0,449.5,666.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 434,
    y: 744,
    width: 31,
    height: 31,
    transform: "rotate(0,449.5,759.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 434,
    y: 775,
    width: 31,
    height: 31,
    transform: "rotate(0,449.5,790.5)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 449.5,
    cy: 852.5,
    r: 15.5,
    transform: "rotate(0,449.5,852.5)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 465 155v 31h 15.5a 15.5 15.5, 0, 0, 0, 0 -31",
    transform: "rotate(-90,480.5,170.5)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 465 186v 31h 15.5a 15.5 15.5, 0, 0, 0, 0 -31",
    transform: "rotate(90,480.5,201.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 465,
    y: 279,
    width: 31,
    height: 31,
    transform: "rotate(0,480.5,294.5)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 465 682v 31h 15.5a 15.5 15.5, 0, 0, 0, 0 -31",
    transform: "rotate(-90,480.5,697.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 465,
    y: 713,
    width: 31,
    height: 31,
    transform: "rotate(0,480.5,728.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 465,
    y: 744,
    width: 31,
    height: 31,
    transform: "rotate(0,480.5,759.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 465,
    y: 775,
    width: 31,
    height: 31,
    transform: "rotate(0,480.5,790.5)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 465 899v 31h 15.5a 15.5 15.5, 0, 0, 0, 0 -31",
    transform: "rotate(180,480.5,914.5)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 496 62v 31h 31v -15.5a 15.5 15.5, 0, 0, 0, -15.5 -15.5",
    transform: "rotate(-90,511.5,77.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 496,
    y: 93,
    width: 31,
    height: 31,
    transform: "rotate(0,511.5,108.5)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 496 124v 31h 15.5a 15.5 15.5, 0, 0, 0, 0 -31",
    transform: "rotate(90,511.5,139.5)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 496 217v 31h 15.5a 15.5 15.5, 0, 0, 0, 0 -31",
    transform: "rotate(-90,511.5,232.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 496,
    y: 248,
    width: 31,
    height: 31,
    transform: "rotate(0,511.5,263.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 496,
    y: 279,
    width: 31,
    height: 31,
    transform: "rotate(0,511.5,294.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 496,
    y: 310,
    width: 31,
    height: 31,
    transform: "rotate(0,511.5,325.5)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 496 341v 31h 31v -15.5a 15.5 15.5, 0, 0, 0, -15.5 -15.5",
    transform: "rotate(180,511.5,356.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 496,
    y: 744,
    width: 31,
    height: 31,
    transform: "rotate(0,511.5,759.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 496,
    y: 775,
    width: 31,
    height: 31,
    transform: "rotate(0,511.5,790.5)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 496 868v 31h 15.5a 15.5 15.5, 0, 0, 0, 0 -31",
    transform: "rotate(-90,511.5,883.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 496,
    y: 899,
    width: 31,
    height: 31,
    transform: "rotate(0,511.5,914.5)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 496 930v 31h 15.5a 15.5 15.5, 0, 0, 0, 0 -31",
    transform: "rotate(90,511.5,945.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 527,
    y: 62,
    width: 31,
    height: 31,
    transform: "rotate(0,542.5,77.5)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 527 186v 31h 15.5a 15.5 15.5, 0, 0, 0, 0 -31",
    transform: "rotate(180,542.5,201.5)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 527 341v 31h 15.5a 15.5 15.5, 0, 0, 0, 0 -31",
    transform: "rotate(0,542.5,356.5)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 542.5,
    cy: 666.5,
    r: 15.5,
    transform: "rotate(0,542.5,666.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 527,
    y: 744,
    width: 31,
    height: 31,
    transform: "rotate(0,542.5,759.5)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 527 775v 31h 31v -15.5a 15.5 15.5, 0, 0, 0, -15.5 -15.5",
    transform: "rotate(90,542.5,790.5)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 527 899v 31h 15.5a 15.5 15.5, 0, 0, 0, 0 -31",
    transform: "rotate(0,542.5,914.5)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 558 62v 31h 31v -15.5a 15.5 15.5, 0, 0, 0, -15.5 -15.5",
    transform: "rotate(0,573.5,77.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 558,
    y: 93,
    width: 31,
    height: 31,
    transform: "rotate(0,573.5,108.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 558,
    y: 124,
    width: 31,
    height: 31,
    transform: "rotate(0,573.5,139.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 558,
    y: 155,
    width: 31,
    height: 31,
    transform: "rotate(0,573.5,170.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 558,
    y: 186,
    width: 31,
    height: 31,
    transform: "rotate(0,573.5,201.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 558,
    y: 217,
    width: 31,
    height: 31,
    transform: "rotate(0,573.5,232.5)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 558 248v 31h 15.5a 15.5 15.5, 0, 0, 0, 0 -31",
    transform: "rotate(90,573.5,263.5)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 558 713v 31h 31v -15.5a 15.5 15.5, 0, 0, 0, -15.5 -15.5",
    transform: "rotate(-90,573.5,728.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 558,
    y: 744,
    width: 31,
    height: 31,
    transform: "rotate(0,573.5,759.5)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 573.5,
    cy: 852.5,
    r: 15.5,
    transform: "rotate(0,573.5,852.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 589,
    y: 155,
    width: 31,
    height: 31,
    transform: "rotate(0,604.5,170.5)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 589 217v 31h 15.5a 15.5 15.5, 0, 0, 0, 0 -31",
    transform: "rotate(0,604.5,232.5)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 589 279v 31h 15.5a 15.5 15.5, 0, 0, 0, 0 -31",
    transform: "rotate(180,604.5,294.5)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 604.5,
    cy: 356.5,
    r: 15.5,
    transform: "rotate(0,604.5,356.5)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 589 682v 31h 15.5a 15.5 15.5, 0, 0, 0, 0 -31",
    transform: "rotate(-90,604.5,697.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 589,
    y: 713,
    width: 31,
    height: 31,
    transform: "rotate(0,604.5,728.5)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 589 744v 31h 31v -15.5a 15.5 15.5, 0, 0, 0, -15.5 -15.5",
    transform: "rotate(90,604.5,759.5)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 589 899v 31h 31v -15.5a 15.5 15.5, 0, 0, 0, -15.5 -15.5",
    transform: "rotate(-90,604.5,914.5)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 589 930v 31h 31v -15.5a 15.5 15.5, 0, 0, 0, -15.5 -15.5",
    transform: "rotate(180,604.5,945.5)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 635.5,
    cy: 77.5,
    r: 15.5,
    transform: "rotate(0,635.5,77.5)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 620 155v 31h 31v -15.5a 15.5 15.5, 0, 0, 0, -15.5 -15.5",
    transform: "rotate(0,635.5,170.5)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 620 186v 31h 15.5a 15.5 15.5, 0, 0, 0, 0 -31",
    transform: "rotate(90,635.5,201.5)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 620 248v 31h 15.5a 15.5 15.5, 0, 0, 0, 0 -31",
    transform: "rotate(-90,635.5,263.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 620,
    y: 279,
    width: 31,
    height: 31,
    transform: "rotate(0,635.5,294.5)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 620 310v 31h 31v -15.5a 15.5 15.5, 0, 0, 0, -15.5 -15.5",
    transform: "rotate(180,635.5,325.5)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 620 713v 31h 15.5a 15.5 15.5, 0, 0, 0, 0 -31",
    transform: "rotate(0,635.5,728.5)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 620 775v 31h 15.5a 15.5 15.5, 0, 0, 0, 0 -31",
    transform: "rotate(180,635.5,790.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 620,
    y: 899,
    width: 31,
    height: 31,
    transform: "rotate(0,635.5,914.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 620,
    y: 930,
    width: 31,
    height: 31,
    transform: "rotate(0,635.5,945.5)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 666.5,
    cy: 108.5,
    r: 15.5,
    transform: "rotate(0,666.5,108.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 651,
    y: 310,
    width: 31,
    height: 31,
    transform: "rotate(0,666.5,325.5)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 651 403v 31h 31v -15.5a 15.5 15.5, 0, 0, 0, -15.5 -15.5",
    transform: "rotate(-90,666.5,418.5)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 651 434v 31h 31v -15.5a 15.5 15.5, 0, 0, 0, -15.5 -15.5",
    transform: "rotate(180,666.5,449.5)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 651 496v 31h 15.5a 15.5 15.5, 0, 0, 0, 0 -31",
    transform: "rotate(-90,666.5,511.5)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 651 527v 31h 15.5a 15.5 15.5, 0, 0, 0, 0 -31",
    transform: "rotate(90,666.5,542.5)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 651 589v 31h 15.5a 15.5 15.5, 0, 0, 0, 0 -31",
    transform: "rotate(180,666.5,604.5)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 651 651v 31h 15.5a 15.5 15.5, 0, 0, 0, 0 -31",
    transform: "rotate(-90,666.5,666.5)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 651 682v 31h 31v -15.5a 15.5 15.5, 0, 0, 0, -15.5 -15.5",
    transform: "rotate(180,666.5,697.5)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 651 744v 31h 31v -15.5a 15.5 15.5, 0, 0, 0, -15.5 -15.5",
    transform: "rotate(-90,666.5,759.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 651,
    y: 775,
    width: 31,
    height: 31,
    transform: "rotate(0,666.5,790.5)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 651 806v 31h 31v -15.5a 15.5 15.5, 0, 0, 0, -15.5 -15.5",
    transform: "rotate(180,666.5,821.5)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 651 899v 31h 31v -15.5a 15.5 15.5, 0, 0, 0, -15.5 -15.5",
    transform: "rotate(0,666.5,914.5)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 651 930v 31h 31v -15.5a 15.5 15.5, 0, 0, 0, -15.5 -15.5",
    transform: "rotate(90,666.5,945.5)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 697.5,
    cy: 77.5,
    r: 15.5,
    transform: "rotate(0,697.5,77.5)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 697.5,
    cy: 139.5,
    r: 15.5,
    transform: "rotate(0,697.5,139.5)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 697.5,
    cy: 263.5,
    r: 15.5,
    transform: "rotate(0,697.5,263.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 682,
    y: 310,
    width: 31,
    height: 31,
    transform: "rotate(0,697.5,325.5)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 682 372v 31h 15.5a 15.5 15.5, 0, 0, 0, 0 -31",
    transform: "rotate(-90,697.5,387.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 682,
    y: 403,
    width: 31,
    height: 31,
    transform: "rotate(0,697.5,418.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 682,
    y: 434,
    width: 31,
    height: 31,
    transform: "rotate(0,697.5,449.5)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 682 558v 31h 15.5a 15.5 15.5, 0, 0, 0, 0 -31",
    transform: "rotate(-90,697.5,573.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 682,
    y: 589,
    width: 31,
    height: 31,
    transform: "rotate(0,697.5,604.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 682,
    y: 682,
    width: 31,
    height: 31,
    transform: "rotate(0,697.5,697.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 682,
    y: 713,
    width: 31,
    height: 31,
    transform: "rotate(0,697.5,728.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 682,
    y: 744,
    width: 31,
    height: 31,
    transform: "rotate(0,697.5,759.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 682,
    y: 775,
    width: 31,
    height: 31,
    transform: "rotate(0,697.5,790.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 682,
    y: 806,
    width: 31,
    height: 31,
    transform: "rotate(0,697.5,821.5)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 697.5,
    cy: 883.5,
    r: 15.5,
    transform: "rotate(0,697.5,883.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 713,
    y: 310,
    width: 31,
    height: 31,
    transform: "rotate(0,728.5,325.5)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 713 341v 31h 15.5a 15.5 15.5, 0, 0, 0, 0 -31",
    transform: "rotate(90,728.5,356.5)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 713 434v 31h 31v -15.5a 15.5 15.5, 0, 0, 0, -15.5 -15.5",
    transform: "rotate(0,728.5,449.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 713,
    y: 465,
    width: 31,
    height: 31,
    transform: "rotate(0,728.5,480.5)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 713 496v 31h 31v -15.5a 15.5 15.5, 0, 0, 0, -15.5 -15.5",
    transform: "rotate(180,728.5,511.5)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 713 589v 31h 15.5a 15.5 15.5, 0, 0, 0, 0 -31",
    transform: "rotate(0,728.5,604.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 713,
    y: 682,
    width: 31,
    height: 31,
    transform: "rotate(0,728.5,697.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 713,
    y: 806,
    width: 31,
    height: 31,
    transform: "rotate(0,728.5,821.5)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 713 899v 31h 15.5a 15.5 15.5, 0, 0, 0, 0 -31",
    transform: "rotate(180,728.5,914.5)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 744 310v 31h 15.5a 15.5 15.5, 0, 0, 0, 0 -31",
    transform: "rotate(0,759.5,325.5)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 744 465v 31h 31v -15.5a 15.5 15.5, 0, 0, 0, -15.5 -15.5",
    transform: "rotate(0,759.5,480.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 744,
    y: 496,
    width: 31,
    height: 31,
    transform: "rotate(0,759.5,511.5)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 744 620v 31h 31v -15.5a 15.5 15.5, 0, 0, 0, -15.5 -15.5",
    transform: "rotate(-90,759.5,635.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 744,
    y: 651,
    width: 31,
    height: 31,
    transform: "rotate(0,759.5,666.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 744,
    y: 682,
    width: 31,
    height: 31,
    transform: "rotate(0,759.5,697.5)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 759.5,
    cy: 759.5,
    r: 15.5,
    transform: "rotate(0,759.5,759.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 744,
    y: 806,
    width: 31,
    height: 31,
    transform: "rotate(0,759.5,821.5)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 744 868v 31h 15.5a 15.5 15.5, 0, 0, 0, 0 -31",
    transform: "rotate(-90,759.5,883.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 744,
    y: 899,
    width: 31,
    height: 31,
    transform: "rotate(0,759.5,914.5)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 744 930v 31h 31v -15.5a 15.5 15.5, 0, 0, 0, -15.5 -15.5",
    transform: "rotate(180,759.5,945.5)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 775 341v 31h 31v -15.5a 15.5 15.5, 0, 0, 0, -15.5 -15.5",
    transform: "rotate(-90,790.5,356.5)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 775 372v 31h 15.5a 15.5 15.5, 0, 0, 0, 0 -31",
    transform: "rotate(90,790.5,387.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 775,
    y: 496,
    width: 31,
    height: 31,
    transform: "rotate(0,790.5,511.5)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 775 558v 31h 31v -15.5a 15.5 15.5, 0, 0, 0, -15.5 -15.5",
    transform: "rotate(-90,790.5,573.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 775,
    y: 589,
    width: 31,
    height: 31,
    transform: "rotate(0,790.5,604.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 775,
    y: 620,
    width: 31,
    height: 31,
    transform: "rotate(0,790.5,635.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 775,
    y: 682,
    width: 31,
    height: 31,
    transform: "rotate(0,790.5,697.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 775,
    y: 806,
    width: 31,
    height: 31,
    transform: "rotate(0,790.5,821.5)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 775 930v 31h 15.5a 15.5 15.5, 0, 0, 0, 0 -31",
    transform: "rotate(0,790.5,945.5)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 806 310v 31h 15.5a 15.5 15.5, 0, 0, 0, 0 -31",
    transform: "rotate(-90,821.5,325.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 806,
    y: 341,
    width: 31,
    height: 31,
    transform: "rotate(0,821.5,356.5)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 806 403v 31h 31v -15.5a 15.5 15.5, 0, 0, 0, -15.5 -15.5",
    transform: "rotate(-90,821.5,418.5)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 806 434v 31h 31v -15.5a 15.5 15.5, 0, 0, 0, -15.5 -15.5",
    transform: "rotate(180,821.5,449.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 806,
    y: 496,
    width: 31,
    height: 31,
    transform: "rotate(0,821.5,511.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 806,
    y: 527,
    width: 31,
    height: 31,
    transform: "rotate(0,821.5,542.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 806,
    y: 558,
    width: 31,
    height: 31,
    transform: "rotate(0,821.5,573.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 806,
    y: 620,
    width: 31,
    height: 31,
    transform: "rotate(0,821.5,635.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 806,
    y: 682,
    width: 31,
    height: 31,
    transform: "rotate(0,821.5,697.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 806,
    y: 713,
    width: 31,
    height: 31,
    transform: "rotate(0,821.5,728.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 806,
    y: 744,
    width: 31,
    height: 31,
    transform: "rotate(0,821.5,759.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 806,
    y: 775,
    width: 31,
    height: 31,
    transform: "rotate(0,821.5,790.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 806,
    y: 806,
    width: 31,
    height: 31,
    transform: "rotate(0,821.5,821.5)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 806 837v 31h 15.5a 15.5 15.5, 0, 0, 0, 0 -31",
    transform: "rotate(90,821.5,852.5)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 821.5,
    cy: 914.5,
    r: 15.5,
    transform: "rotate(0,821.5,914.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 837,
    y: 341,
    width: 31,
    height: 31,
    transform: "rotate(0,852.5,356.5)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 837 403v 31h 31v -15.5a 15.5 15.5, 0, 0, 0, -15.5 -15.5",
    transform: "rotate(0,852.5,418.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 837,
    y: 434,
    width: 31,
    height: 31,
    transform: "rotate(0,852.5,449.5)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 837 496v 31h 31v -15.5a 15.5 15.5, 0, 0, 0, -15.5 -15.5",
    transform: "rotate(0,852.5,511.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 837,
    y: 527,
    width: 31,
    height: 31,
    transform: "rotate(0,852.5,542.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 837,
    y: 558,
    width: 31,
    height: 31,
    transform: "rotate(0,852.5,573.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 837,
    y: 620,
    width: 31,
    height: 31,
    transform: "rotate(0,852.5,635.5)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 837 682v 31h 31v -15.5a 15.5 15.5, 0, 0, 0, -15.5 -15.5",
    transform: "rotate(0,852.5,697.5)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 837 713v 31h 31v -15.5a 15.5 15.5, 0, 0, 0, -15.5 -15.5",
    transform: "rotate(90,852.5,728.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 837,
    y: 806,
    width: 31,
    height: 31,
    transform: "rotate(0,852.5,821.5)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 837 868v 31h 15.5a 15.5 15.5, 0, 0, 0, 0 -31",
    transform: "rotate(180,852.5,883.5)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 868 310v 31h 31v -15.5a 15.5 15.5, 0, 0, 0, -15.5 -15.5",
    transform: "rotate(-90,883.5,325.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 868,
    y: 341,
    width: 31,
    height: 31,
    transform: "rotate(0,883.5,356.5)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 868 434v 31h 31v -15.5a 15.5 15.5, 0, 0, 0, -15.5 -15.5",
    transform: "rotate(0,883.5,449.5)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 868 465v 31h 31v -15.5a 15.5 15.5, 0, 0, 0, -15.5 -15.5",
    transform: "rotate(180,883.5,480.5)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 868 527v 31h 31v -15.5a 15.5 15.5, 0, 0, 0, -15.5 -15.5",
    transform: "rotate(0,883.5,542.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 868,
    y: 558,
    width: 31,
    height: 31,
    transform: "rotate(0,883.5,573.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 868,
    y: 620,
    width: 31,
    height: 31,
    transform: "rotate(0,883.5,635.5)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 868 651v 31h 31v -15.5a 15.5 15.5, 0, 0, 0, -15.5 -15.5",
    transform: "rotate(180,883.5,666.5)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 868 775v 31h 31v -15.5a 15.5 15.5, 0, 0, 0, -15.5 -15.5",
    transform: "rotate(-90,883.5,790.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 868,
    y: 806,
    width: 31,
    height: 31,
    transform: "rotate(0,883.5,821.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 868,
    y: 837,
    width: 31,
    height: 31,
    transform: "rotate(0,883.5,852.5)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 868 868v 31h 31v -15.5a 15.5 15.5, 0, 0, 0, -15.5 -15.5",
    transform: "rotate(90,883.5,883.5)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 883.5,
    cy: 945.5,
    r: 15.5,
    transform: "rotate(0,883.5,945.5)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 899 310v 31h 31v -15.5a 15.5 15.5, 0, 0, 0, -15.5 -15.5",
    transform: "rotate(0,914.5,325.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 899,
    y: 341,
    width: 31,
    height: 31,
    transform: "rotate(0,914.5,356.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 899,
    y: 372,
    width: 31,
    height: 31,
    transform: "rotate(0,914.5,387.5)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 899 403v 31h 15.5a 15.5 15.5, 0, 0, 0, 0 -31",
    transform: "rotate(90,914.5,418.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 899,
    y: 465,
    width: 31,
    height: 31,
    transform: "rotate(0,914.5,480.5)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 899 496v 31h 31v -15.5a 15.5 15.5, 0, 0, 0, -15.5 -15.5",
    transform: "rotate(180,914.5,511.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 899,
    y: 558,
    width: 31,
    height: 31,
    transform: "rotate(0,914.5,573.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 899,
    y: 589,
    width: 31,
    height: 31,
    transform: "rotate(0,914.5,604.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 899,
    y: 620,
    width: 31,
    height: 31,
    transform: "rotate(0,914.5,635.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 899,
    y: 651,
    width: 31,
    height: 31,
    transform: "rotate(0,914.5,666.5)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 899 713v 31h 15.5a 15.5 15.5, 0, 0, 0, 0 -31",
    transform: "rotate(-90,914.5,728.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 899,
    y: 744,
    width: 31,
    height: 31,
    transform: "rotate(0,914.5,759.5)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 899 775v 31h 31v -15.5a 15.5 15.5, 0, 0, 0, -15.5 -15.5",
    transform: "rotate(90,914.5,790.5)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 899 899v 31h 15.5a 15.5 15.5, 0, 0, 0, 0 -31",
    transform: "rotate(180,914.5,914.5)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 930 341v 31h 31v -15.5a 15.5 15.5, 0, 0, 0, -15.5 -15.5",
    transform: "rotate(0,945.5,356.5)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 930 372v 31h 31v -15.5a 15.5 15.5, 0, 0, 0, -15.5 -15.5",
    transform: "rotate(90,945.5,387.5)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 930 465v 31h 31v -15.5a 15.5 15.5, 0, 0, 0, -15.5 -15.5",
    transform: "rotate(0,945.5,480.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 930,
    y: 496,
    width: 31,
    height: 31,
    transform: "rotate(0,945.5,511.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 930,
    y: 527,
    width: 31,
    height: 31,
    transform: "rotate(0,945.5,542.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 930,
    y: 558,
    width: 31,
    height: 31,
    transform: "rotate(0,945.5,573.5)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 930 589v 31h 31v -15.5a 15.5 15.5, 0, 0, 0, -15.5 -15.5",
    transform: "rotate(90,945.5,604.5)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 930 651v 31h 31v -15.5a 15.5 15.5, 0, 0, 0, -15.5 -15.5",
    transform: "rotate(0,945.5,666.5)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 930 682v 31h 15.5a 15.5 15.5, 0, 0, 0, 0 -31",
    transform: "rotate(90,945.5,697.5)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 930 744v 31h 15.5a 15.5 15.5, 0, 0, 0, 0 -31",
    transform: "rotate(0,945.5,759.5)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 945.5,
    cy: 821.5,
    r: 15.5,
    transform: "rotate(0,945.5,821.5)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 930 868v 31h 15.5a 15.5 15.5, 0, 0, 0, 0 -31",
    transform: "rotate(-90,945.5,883.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 930,
    y: 899,
    width: 31,
    height: 31,
    transform: "rotate(0,945.5,914.5)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 930 930v 31h 15.5a 15.5 15.5, 0, 0, 0, 0 -31",
    transform: "rotate(90,945.5,945.5)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-corners-square-color-0-0"
  }, /*#__PURE__*/React.createElement("path", {
    clipRule: "evenodd",
    d: "M 62 139.5v 62a 77.5 77.5, 0, 0, 0, 77.5 77.5h 62a 77.5 77.5, 0, 0, 0, 77.5 -77.5v -62a 77.5 77.5, 0, 0, 0, -77.5 -77.5h -62a 77.5 77.5, 0, 0, 0, -77.5 77.5M 139.5 93h 62a 46.5 46.5, 0, 0, 1, 46.5 46.5v 62a 46.5 46.5, 0, 0, 1, -46.5 46.5h -62a 46.5 46.5, 0, 0, 1, -46.5 -46.5v -62a 46.5 46.5, 0, 0, 1, 46.5 -46.5",
    transform: "rotate(0,170.5,170.5)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-corners-dot-color-0-0"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 170.5,
    cy: 170.5,
    r: 46.5,
    transform: "rotate(0,170.5,170.5)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-corners-square-color-1-0"
  }, /*#__PURE__*/React.createElement("path", {
    clipRule: "evenodd",
    d: "M 744 139.5v 62a 77.5 77.5, 0, 0, 0, 77.5 77.5h 62a 77.5 77.5, 0, 0, 0, 77.5 -77.5v -62a 77.5 77.5, 0, 0, 0, -77.5 -77.5h -62a 77.5 77.5, 0, 0, 0, -77.5 77.5M 821.5 93h 62a 46.5 46.5, 0, 0, 1, 46.5 46.5v 62a 46.5 46.5, 0, 0, 1, -46.5 46.5h -62a 46.5 46.5, 0, 0, 1, -46.5 -46.5v -62a 46.5 46.5, 0, 0, 1, 46.5 -46.5",
    transform: "rotate(90,852.5,170.5)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-corners-dot-color-1-0"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 852.5,
    cy: 170.5,
    r: 46.5,
    transform: "rotate(90,852.5,170.5)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-corners-square-color-0-1"
  }, /*#__PURE__*/React.createElement("path", {
    clipRule: "evenodd",
    d: "M 62 821.5v 62a 77.5 77.5, 0, 0, 0, 77.5 77.5h 62a 77.5 77.5, 0, 0, 0, 77.5 -77.5v -62a 77.5 77.5, 0, 0, 0, -77.5 -77.5h -62a 77.5 77.5, 0, 0, 0, -77.5 77.5M 139.5 775h 62a 46.5 46.5, 0, 0, 1, 46.5 46.5v 62a 46.5 46.5, 0, 0, 1, -46.5 46.5h -62a 46.5 46.5, 0, 0, 1, -46.5 -46.5v -62a 46.5 46.5, 0, 0, 1, 46.5 -46.5",
    transform: "rotate(-90,170.5,852.5)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-corners-dot-color-0-1"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 170.5,
    cy: 852.5,
    r: 46.5,
    transform: "rotate(-90,170.5,852.5)"
  })))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    height: 1024,
    width: 1024,
    clipPath: "url('#clip-path-background-color')",
    fill: "#ffffff"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 62,
    y: 62,
    height: 899,
    width: 899,
    clipPath: "url('#clip-path-dot-color')",
    fill: "#000000"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 62,
    y: 62,
    height: 217,
    width: 217,
    clipPath: "url('#clip-path-corners-square-color-0-0')",
    fill: "#000000"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 124,
    y: 124,
    height: 93,
    width: 93,
    clipPath: "url('#clip-path-corners-dot-color-0-0')",
    fill: "#000000"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 744,
    y: 62,
    height: 217,
    width: 217,
    clipPath: "url('#clip-path-corners-square-color-1-0')",
    fill: "#000000"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 806,
    y: 124,
    height: 93,
    width: 93,
    clipPath: "url('#clip-path-corners-dot-color-1-0')",
    fill: "#000000"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 62,
    y: 744,
    height: 217,
    width: 217,
    clipPath: "url('#clip-path-corners-square-color-0-1')",
    fill: "#000000"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 124,
    y: 806,
    height: 93,
    width: 93,
    clipPath: "url('#clip-path-corners-dot-color-0-1')",
    fill: "#000000"
  })), _image || (_image = /*#__PURE__*/React.createElement("image", {
    href: "https://img.qrfy.com/img/large/8f9fced1-d56b-400e-93a9-8ee6de64b72f.webp",
    x: 372,
    y: 372,
    width: "279px",
    height: "279px"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTecamaQrcode);
export default __webpack_public_path__ + "static/media/tecama-qrcode.d3824374049083fb50c7116ca638d099.svg";
export { ForwardRef as ReactComponent };